/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Book from './book-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Book {...validProps} />;
}
SvgComponent.iconName = 'book';

export const BookIcon = svgIconWrapper(SvgComponent);
